var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 2,
    fill: "#F3F4F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.122 25.1235C25.706 24.5408 25.998 23.8328 25.998 22.9995C25.998 22.1662 25.706 21.4582 25.122 20.8755C24.538 20.2928 23.83 20.0008 22.998 19.9995C22.166 19.9982 21.458 20.2902 20.874 20.8755C20.29 21.4608 19.998 22.1688 19.998 22.9995C19.998 23.8302 20.29 24.5382 20.874 25.1235C21.458 25.7088 22.166 26.0008 22.998 25.9995C23.83 25.9982 24.538 25.7062 25.122 25.1235Z",
    fill: "#3F51B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2632 33.3405L34.0706 24.6286C34.2693 24.3305 34.7077 24.3319 34.9045 24.6313L45.49 40.7389C45.7085 41.0714 45.47 41.5135 45.0721 41.5135H16.922C16.5249 41.5135 16.2863 41.073 16.5031 40.7404L24.2735 28.824C24.4671 28.5271 24.8995 28.5203 25.1024 28.811L28.2632 33.3405Z",
    fill: "#D9DCF0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/ImagePlaceholder.4105d88294f46f4c36de63ddfc72e3af.svg";
export { ForwardRef as ReactComponent };